import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 9 9",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 4.36426,
		cy: 4.02356,
		r: 4
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 4.36426,
		cy: 4.02356,
		r: 2,
		transform: "rotate(-180 4.36426 4.02356)",
		fill: "white"
	})]
});
export default SvgCircleWhite;
